/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'phone': {
    width: 24,
    height: 24,
    viewBox: '0 0 24 24',
    data: '<path pid="0" d="M22.236 1.213c.494.135.854.539.854 1.033 0 11.545-9.344 20.844-20.844 20.844-.539 0-.943-.315-1.078-.809L.09 17.61c-.09-.494.135-1.033.629-1.257l5.031-2.157c.45-.18.943-.045 1.258.315l2.246 2.74a16.863 16.863 0 007.951-7.951l-2.74-2.246a1.113 1.113 0 01-.315-1.258L16.307.764C16.53.27 17.07 0 17.565.134l4.671 1.079z" _fill="#3E4749"/>'
  }
})
